import axios from 'axios';

const submitFilters = (surveyId, filters = {}) =>
  axios.post(`/call_centers/apply_pre_filters`, {
    survey_id: surveyId,
    filters,
  });

// eslint-disable-next-line import/prefer-default-export
export { submitFilters };
